import { Injectable } from '@angular/core';
import { ModeModelBase } from '../model';
import { ModelAccessorBase, ModelAccessorInjectables } from '../model_accessor';

export class ColorPaletteModel extends ModeModelBase {
  override _name = 'colorPalette';
  override idAttribute = 'token';
  override belongsTo = 'account';
  override parentIdAttribute = 'username';
  override attributes = [
    { name: 'name', default: '' },
    { name: 'palette_type', default: 'categorical' },
    { name: 'value', default: '' },
    { name: 'is_default', default: false },
  ];
}

@Injectable({ providedIn: 'root' })
export class ColorPaletteModelAccessor extends ModelAccessorBase<ColorPaletteModel> {
  override name = 'colorPalette';
  override idAttribute = 'token';
  override parentModel = 'account';
  override parentIdAttribute = 'username';
  override getIdFromLink = (link) => {
    return link.split('/color_palettes/')[1];
  };

  constructor(injectables: ModelAccessorInjectables) {
    super(injectables, 'migrated', 'mode.colorPalette');
  }

  createModel = function (resource, opts?) {
    const model = new ColorPaletteModel(this.injectables.modelInjectables);
    model.$initialize(resource, opts);
    return model;
  };
}
